import UmlDiagramItem from './UmlDiagramItem';

// Punt zonder eigen box: geen w/h/zIndex. Basis voor UmlCaption en UmlConnectorPoint.
class UmlFreePoint extends UmlDiagramItem {
  constructor(id, x, y) {
    super(id, x, y);
  }
}

export default UmlFreePoint;
